import { useState, useEffect } from 'react'
import { Chart } from '@scuf/charts';
// import { TimeSeries } from '@scuf/charts'
import { Card } from '@scuf/common'
import { useDispatch } from 'react-redux'
import ColumnData from './ColumnData'
import ColumnDataAPI from './ColumnDataAPI'
import baseServices from '../../../services/base.services';
import { startLineChart } from '../../../actions/entryDataChart'
// import TitlePage from '../../../components/TitlePage/TitlePage';

const Column = ({ url, body, isCard, titleCard, name }) => {

    const dispatch = useDispatch();
    const [state, setState] = useState([])

    useEffect(() => {


        const getData = async () => {
            try {
                if (body) {
                    var response = await baseServices.getDataN2(body, url);
                    if (response.data && response.data.length > 0) {
                        //dispatch(startLineChart(response.data[0]))                    
                        setState(ColumnDataAPI(response))
                        setTimeout(() => {
                            getData()
                        }, 150000);

                    }
                } else {
                    setState(ColumnData())
                    dispatch(startLineChart('dummy data'))
                    setTimeout(() => {
                        getData()
                    }, 150000);
                }

            } catch (err) {
                setTimeout(() => {
                    getData()
                }, 15000);
            }



        }

        getData()

    }, [body, dispatch, url])


    return (
        <>
            {
                isCard === '1' ?
                    <Card className='m-0'>
                        {/* <div className='mayus'>
                            <Card.Header title={titleCard} className='m-0 p-0'></Card.Header>
                        </div> */}
                        <Card.Content style={{ minHeight: '0px' }} className='m-0 p-0'>
                            <Chart height={160} inverted={false} showLegend={false} >
                                <Chart.Title className='m-0' text={titleCard} align='left' />
                                <Chart.YAxis max={100} visible={true} />

                                <Chart.Column name={name} data={state.datos} />
                                <Chart.XAxis categories={state.categories} />

                            </Chart>
                        </Card.Content>
                    </Card>
                    :
                    <div style={{ marginTop: "-15px" }}>
                        <Chart height={160} inverted={false} showLegend={false} >
                            <Chart.Title className='m-0' text={titleCard} align='left' />
                            <Chart.YAxis showGridLines={false} max={100} visible={true} />

                            <Chart.Column name={name} data={state.datos} pointWidth={15} />
                            <Chart.XAxis categories={state.categories} />


                        </Chart>
                    </div>
            }
        </>


    )
}

export default Column
